import React, { createContext, useContext, useState } from 'react';
// import { signal, effect } from '@preact/signals-react'

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const [title, setTitle] = useState([]);
  const [breadcrumbsFromPath, updateBreadcrumbsFromPath] = useState([]);

  const updateTitle = (newTitle) => {
    setTitle(newTitle);
  };

  return (
    <AppContext.Provider
      value={{
        pageTitle,
        setPageTitle,
        activeTab,
        setActiveTab,
        title,
        updateTitle,
        updateBreadcrumbsFromPath,
        breadcrumbsFromPath,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
